import React, { useRef, useState } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import JoditEditor from "jodit-react";
import Swal from "sweetalert2";

const Privacy = () => {
  const editor = useRef(null);
  const [text, setText] = useState("");
  const [cont, setContent] = useState("");
  const [msg, setMsg] = useState("");

  const config = {
    placeholder: "Start typings...",
  };

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });
  useEffect(() => {
    axios.get("/api/privacypolicy").then((res) => {
      setText(res.data.data);
    });
  }, []);

  const updateText = async (e) => {
    e.preventDefault();
    const privacyobj = new FormData();
    privacyobj.append("content", cont);
    await axios
      .post("/api/update_privacypolicy/" + 1, privacyobj, {
        header: {
          accept: "application/json",
        },
      })
      .then((result) => {
        Toast.fire({
          icon: "success",
          title: result.data.message,
        });
      })
      .catch((error) => {
        Toast.fire({
          icon: "error",
          title: error.response.data.message,
        });
      });
  };

  const navigate = useNavigate();
  useEffect(() => {
    if (!localStorage.getItem("status")) {
      navigate("/");
    }
  }, [navigate]);

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-2 p-0">
            <Sidebar />
          </div>
          <div className="col-sm-10 ">
            <div className="container-fluid">
              <Navbar />
              <div className="p-2 bg-white  ml-3">
                <span>
                  <Link to="/dashboard">Dashboard</Link> / Privacy
                </span>
              </div>
              <div
                className="bg-gre  ml-3"
                style={{ padding: "35px", minHeight: "560px" }}
              >
                <center>
                  <h3>Please Write The Text For Privacy Policy</h3>
                </center>
                <JoditEditor
                  ref={editor}
                  value={text.content}
                  config={config}
                  name="content"
                  tabIndex={1}
                  onBlur={(newContent) => setContent(newContent)}
                  onChange={(newContent) => {}}
                />
                <button
                  className="btn btn-danger mt-2"
                  onClick={updateText}
                  style={{ marginLeft: "45%" }}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Privacy;
